import { Dispatch } from 'redux'
import { NavBarActionType } from "../action-types/navBarTypes"
import { Action } from '../actions/navBarActions'

export const switchNavbar = (switchTo: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: NavBarActionType.SWITCH,
            payload: switchTo
        })
    }
}